import { apiClient } from '@shared/utils/api-client';
import type {
  SellerSupportMessage,
  SellerSupportMessagesResponse,
  SellerSupportThreadSummary,
  SellerSupportThreadsResponse,
} from '../types';

export const SELLER_SUPPORT_CHAT_MAX_IMAGES = 5;

export const sellerSupportChatApi = {
  getUnreadCount: () =>
    apiClient.get<{ count: number }>('/seller-support-chat/admin/unread-count'),

  listThreads: (params?: { limit?: number; offset?: number }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.offset != null) search.set('offset', String(params.offset));
    const q = search.toString();
    return apiClient.get<SellerSupportThreadsResponse>(
      `/seller-support-chat/admin/threads${q ? `?${q}` : ''}`,
    );
  },

  ensureThread: (sellerId: number) =>
    apiClient.post<SellerSupportThreadSummary>(
      `/seller-support-chat/admin/sellers/${sellerId}/thread`,
      {},
    ),

  getMessages: (sellerId: number, params?: { limit?: number; beforeId?: number }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.beforeId != null) search.set('beforeId', String(params.beforeId));
    const q = search.toString();
    return apiClient.get<SellerSupportMessagesResponse>(
      `/seller-support-chat/admin/sellers/${sellerId}/messages${q ? `?${q}` : ''}`,
    );
  },

  sendMessage: async (sellerId: number, body: string, images?: File[]) => {
    const formData = new FormData();
    const trimmed = body.trim();
    if (trimmed) formData.append('body', trimmed);
    if (images && images.length > 0) {
      images.forEach((file) => formData.append('images', file));
    }
    return apiClient.post<SellerSupportMessage>(
      `/seller-support-chat/admin/sellers/${sellerId}/messages`,
      formData,
    );
  },

  markRead: (sellerId: number) =>
    apiClient.patch<{ ok: boolean; marked: number }>(
      `/seller-support-chat/admin/sellers/${sellerId}/read`,
      {},
    ),
};
